
/* ========== harvest helpers ========== */
function isRealUrl(u){ return u && !/placeholder|blank\.|data:image\/svg|data:image\/gif/i.test(u); }
function pickFromSrcset(ss){
  if (!ss) return '';
  let best = '', bestW = 0;
  ss.split(',').forEach(p => {
    const m = p.trim().match(/(\S+)\s+(\d+)w/);
    if (m){ const url=m[1], w=+m[2]; if (w>bestW){ best=url; bestW=w; } }
  });
  return best || ss.split(',')[0]?.trim().split(/\s+/)[0] || '';
}
function bestImgSrc(img){
  const ds = img?.dataset || {};
  return (
    (img?.currentSrc && isRealUrl(img.currentSrc) && img.currentSrc) ||
    (img?.srcset && isRealUrl(pickFromSrcset(img.srcset)) && pickFromSrcset(img.srcset)) ||
    (ds.srcset && isRealUrl(pickFromSrcset(ds.srcset)) && pickFromSrcset(ds.srcset)) ||
    (ds.instafeedSrcset && isRealUrl(pickFromSrcset(ds.instafeedSrcset)) && pickFromSrcset(ds.instafeedSrcset)) ||
    (ds.src && isRealUrl(ds.src) && ds.src) ||
    (ds.instafeedSrc && isRealUrl(ds.instafeedSrc) && ds.instafeedSrc) ||
    (img?.src && isRealUrl(img.src) && img.src) ||
    ''
  );
}

/* ========== renderer (fixed grid, auto-sized tiles) ========== */
function runMyInstaClone(allItems){
  // cleanup
  document.getElementById('my-insta-clone')?.remove();
  document.getElementById('my-insta-clone-style')?.remove();

  const FEED_ROOT = document.querySelector('#insta-feed');
  if (!FEED_ROOT) return console.error('[my-insta] #insta-feed not found');

  // host
  const host = document.createElement('section');
  host.id = 'my-insta-clone';
  host.setAttribute('aria-label','Custom Instagram feed');
  const FOOTER = document.querySelector('footer');
  if (FOOTER?.parentNode) FOOTER.parentNode.insertBefore(host, FOOTER);
  else FEED_ROOT.insertAdjacentElement('afterend', host);

  // CSS
  const style = document.createElement('style');
  style.id='my-insta-clone-style';
  style.textContent = `
    #insta-feed .instafeed-new-layout-container{ display:none !important; }
    #my-insta-clone{ margin:100px 0; overflow:visible; padding: 0 50px;}

    #my-insta-clone .my-insta-grid{
      --gap:22px;
      --tile: 200px;               /* JS sets exact px so row always fits */
      display:grid;
      gap:var(--gap);
      justify-content:center;
      align-items:center;
      overflow:visible;
    }
      #my-insta-clone .my-insta-grid{ width:100%; }
    /* columns set by JS via class */
    #my-insta-clone .my-insta-grid.layout-7{ grid-template-columns: repeat(7, var(--tile)); } /* desktop */
    #my-insta-clone .my-insta-grid.layout-5{ grid-template-columns: repeat(5, var(--tile)); } /* tablet */
    #my-insta-clone .my-insta-grid.layout-3{ grid-template-columns: repeat(3, var(--tile)); } /* mobile */

    #my-insta-clone .my-insta-item{
      width:var(--tile);
      aspect-ratio:1/1;
      height:auto;
      background:#f0f0f0;
      position:relative;
      overflow:hidden;
      contain:content;
    }
    #my-insta-clone .my-insta-item a{ display:block; width:100%; height:100%; }
    #my-insta-clone .my-insta-item img{
      width:100%; height:100%; object-fit:cover; display:block;
      transition:transform .25s ease;
    }
    #my-insta-clone .my-insta-item:hover img{ transform:scale(1.03); }

    /* Brand tile (never cut off) */
    #my-insta-clone .my-insta-item.brand{
      display:flex; align-items:center; justify-content:center;
      background:#f7f7f7;
      min-height:var(--tile);
      height:auto;
      overflow:visible;
      text-align:center;
    }
    #my-insta-clone .my-insta-item.brand .brand-btn{
      display: flex;
      padding:.75rem 1rem;
      font-weight:bold;
      color:#592A0E;
      font-family: 'Work Sans';
      background:#f2f2f2;
      text-decoration:none;
      letter-spacing:.08em;
      line-height:1.15;
      transition:opacity .2s, transform .2s;
      max-width:100%;
      white-space:normal;
      overflow-wrap:anywhere;
      word-break:break-word;
      justify-content: center;
      align-items: center;
    }
    #my-insta-clone .my-insta-item.brand .brand-btn:hover{ opacity:.9; transform:translateY(-1px); }

    /* Handle text variants */
    #my-insta-clone .brand-handle--split{ display:inline; }
    @media (max-width: 991px){              /* tablet + mobile only */
      #my-insta-clone .brand-handle--full{ display:none; }
      #my-insta-clone .brand-handle--split{ display:inline; }
    }

    @media (max-width:640px){
    #my-insta-clone{
        padding: 0 30px;
        margin: 50px 0;
    }
      #my-insta-clone .my-insta-item.brand .brand-btn{
        letter-spacing:.04em; padding:.6rem .8rem;
      }
        #my-insta-clone .my-insta-grid{ --gap:16px; } 
        
    }
  `;
  document.head.appendChild(style);

  const HANDLE_TEXT='@ASHLEYTISDALEFRENCH';
  const HANDLE_URL ='https://www.instagram.com/ashleytisdalefrench/';
  const grid = document.createElement('div');
  grid.className = 'my-insta-grid';

  const buildBrand = () => {
    const fig = document.createElement('figure');
    fig.className = 'my-insta-item brand';
    // Full (desktop) vs Split (tablet/mobile) — split inserts a soft break after ASHLEY only when <991px
    fig.innerHTML = `
      <a class="brand-btn" href="${HANDLE_URL}" target="_blank" rel="noopener nofollow"
         aria-label="Open ${HANDLE_TEXT} on Instagram">
        <span class="brand-handle brand-handle--split social-text" aria-hidden="true">@ASHLEY<wbr>TISDALE<wbr>FRENCH</span>
      </a>`;
    return fig;
  };
  const buildTile = ({href,src,alt}, i) => {
    const fig = document.createElement('figure');
    fig.className = 'my-insta-item';
    fig.innerHTML = `
      <a href="${href}" target="_blank" rel="noopener nofollow" aria-label="Open Instagram post ${i+1}">
        <img loading="lazy" referrerpolicy="no-referrer" src="${src}" alt="${(alt||'').replace(/"/g,'&quot;')}">
      </a>`;
    return fig;
  };

  // --- layout logic + exact tile sizing (prevents overflow) ---
  let forceMode = 'auto'; // 'auto' | 'desktop' | 'tablet' | 'mobile'

  function getMode(){
    if (forceMode !== 'auto') return forceMode;
    if (matchMedia('(max-width: 640px)').matches) return 'mobile';
    if (matchMedia('(max-width: 991px)').matches) return 'tablet';
    return 'desktop';
  }

 function computeTilePx(cols){
  // must match CSS (phones override to 16px)
  const GAP = matchMedia('(max-width: 640px)').matches ? 16 : 22;

  // slightly smaller minimum on phones so 3 tiles always fit
  const minPx = matchMedia('(max-width: 640px)').matches ? 102 : 140;
  const maxPx = 240;

  // inner width = host width minus paddings
  const rect = host.getBoundingClientRect();
  const cs = getComputedStyle(host);
  const inner = rect.width - (parseFloat(cs.paddingLeft||0) + parseFloat(cs.paddingRight||0));

  const totalGaps = GAP * (cols - 1);
  const raw = Math.floor((inner - totalGaps) / cols);

  // -1px safety avoids rare subpixel wrap
  return Math.max(minPx, Math.min(maxPx, raw)) - 1;
}



  function renderOnce(){
    grid.innerHTML = '';

    const mode = getMode();
    const cfg = (mode==='mobile') ? {cls:'layout-3', L:2, R:0, cols:3}
             : (mode==='tablet') ? {cls:'layout-5', L:2, R:2, cols:5}
                                 : {cls:'layout-7', L:3, R:3, cols:7};

    grid.classList.remove('layout-3','layout-5','layout-7');
    grid.classList.add(cfg.cls);
    grid.style.setProperty('--tile', computeTilePx(cfg.cols) + 'px');

    // choose items (fallback if fewer exist)
    const L = Math.min(cfg.L, allItems.length);
    const R = Math.min(cfg.R, Math.max(0, allItems.length - L));
    const leftItems  = allItems.slice(0, L);
    const rightItems = allItems.slice(L, L+R);

    const frag = document.createDocumentFragment();
    leftItems.forEach((it,i)=>frag.appendChild(buildTile(it, i)));
    frag.appendChild(buildBrand());
    rightItems.forEach((it,i)=>frag.appendChild(buildTile(it, L+i)));
    grid.appendChild(frag);
  }

  renderOnce();
  host.appendChild(grid);

  // responsive + container-size reflow
  let lastW = 0, lastMode = '';
  function maybeRerender(){
    const mode = getMode();
    const w = host.clientWidth;
    if (mode !== lastMode || Math.abs(w - lastW) > 8){
      lastMode = mode; lastW = w;
      renderOnce();
    }
  }
  const ro = new ResizeObserver(maybeRerender);
  ro.observe(host);
  window.addEventListener('resize', maybeRerender);

  // API (includes manual layout toggling)
  window.myInsta = {
    data: allItems,
    rerender: renderOnce,
    setMode(m){ forceMode = (m==='desktop'||m==='tablet'||m==='mobile') ? m : 'auto'; maybeRerender(); },
    destroy(){
      ro.disconnect();
      window.removeEventListener('resize', maybeRerender);
      document.getElementById('my-insta-clone')?.remove();
      document.getElementById('my-insta-clone-style')?.remove();
      console.log('[my-insta] destroyed');
    }
  };

  console.log('[my-insta] grid rendered; mode=', getMode());
}

/* ========== smart harvester (waits for real thumbs) ========== */
async function harvestWhenReady({min=2, timeout=7000, checkEvery=150}={}){
  const FEED_ROOT = document.querySelector('#insta-feed');
  if (!FEED_ROOT) return [];
  const SEL = '.instafeed-new-layout-item a[href]';
  const t0 = performance.now();

  function harvest(){
    const cards = [...FEED_ROOT.querySelectorAll(SEL)];
    return cards.map(a=>{
      const img = a.querySelector('img');
      const src = img ? bestImgSrc(img) : '';
      return { href: a.href, src, alt: img?.alt || '' };
    }).filter(x => x.href && isRealUrl(x.src));
  }

  return await new Promise(resolve=>{
    const tick = ()=>{
      const items = harvest();
      if (items.length >= min || (performance.now() - t0) > timeout){
        resolve(items);
      } else setTimeout(tick, checkEvery);
    };
    tick();
  });
}

/* ========== bootstrap: wait for OG feed then render ========== */
(function myInstaBootstrap(){
  if (window.__myInstaBooted) return;
  const READY_SEL = '#insta-feed .instafeed-new-layout-item a[href]';
  const haveNodes = () => !!document.querySelector(READY_SEL);

  async function start(){
    if (window.__myInstaBooted) return;
    window.__myInstaBooted = true;
    const items = await harvestWhenReady({min:2, timeout:7000});
    if (!items.length){ console.warn('[my-insta] No real images resolved; showing brand-only.'); }
    runMyInstaClone(items);
  }

  if (haveNodes()) start();
  else {
    const mo = new MutationObserver((m,obs)=>{
      if (haveNodes()){ obs.disconnect(); start(); }
    });
    mo.observe(document.documentElement || document.body, {childList:true, subtree:true});
    setTimeout(()=>mo.disconnect(), 15000);
  }

  // manual controls
  window.myInstaBootstrap = {
    force: start,
    reset(){ window.__myInstaBooted=false; window.myInsta?.destroy?.(); }
  };

  console.log('[my-insta] bootstrap: waiting for OG feed…');
})();

/* ========== announcement-bar safety patch ========== */
(function patchAnnouncementResize() {
  function install() {
    const Ctor = customElements.get('announcement-bar');
    if (!Ctor || !Ctor.prototype) return false;
    const proto = Ctor.prototype, orig = proto.resize;
    if (typeof orig !== 'function') return true;
    proto.resize = function (...args) {
      try {
        const tgt = this._resizeTarget ||
          this.querySelector('[data-announcement-slider], .announcement-bar__slider, [role="marquee"]');
        if (!tgt || typeof tgt.dispatchEvent !== 'function') return;
        return orig.apply(this, args);
      } catch (e) { console.warn('[patch] suppressed announcement-bar resize error:', e); }
    };
    console.log('[patch] announcement-bar.resize wrapped safely'); return true;
  }
  if (!install()) {
    const id = setInterval(() => install() && clearInterval(id), 50);
    setTimeout(() => clearInterval(id), 2000);
  }
})();
